import { render, staticRenderFns } from "./IcoGift.vue?vue&type=template&id=2033978c"
import script from "./IcoGift.vue?vue&type=script&lang=js"
export * from "./IcoGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports